const state = {
  smsList: []
};
const mutations = {
  SET_DOD_SMS_LIST(state, smsList) {
    state.smsList = smsList
  }
};
const getters = {
  getDodSmsList: state => state.smsList
};

export default {
  state,
  mutations,
  getters,
};